import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { restoreSingleShipment } from '../../store/orders/orders.api';
import { RestoreButton } from './restore-button';

import messages from './messages';

export const RestoreShipped = ({ fulfillmentPlanId }) => {
  const onRestore = useCallback(() => {
    return restoreSingleShipment(fulfillmentPlanId);
  }, [fulfillmentPlanId]);

  return <RestoreButton headerTitle={messages.restoreShippedHeaderTitle} onClick={onRestore} />;
};

RestoreShipped.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
